export default __webpack_public_path__ + "static/media/David-Magaya.2929daef.jpg";